export const novaGradientClass = {
  aiBorderIcon:
    'bg-[linear-gradient(107.44031564647187deg,var(--color-wtw-infinity-250)_0%,var(--color-wtw-ultraviolet-200)_78.65%)]',
  aiBackground:
    'bg-[linear-gradient(117.49660041357268deg,var(--color-wtw-infinity-150)_1.928%,var(--color-wtw-ultraviolet-200)_81.716%)]',
} as const;

export const novaGradientStateClass = {
  aiBorderIconFocusWithin:
    'focus-within:bg-[linear-gradient(107.44031564647187deg,var(--color-wtw-infinity-250)_0%,var(--color-wtw-ultraviolet-200)_78.65%)]',
  aiBorderIconHover:
    'hover:bg-[linear-gradient(107.44031564647187deg,var(--color-wtw-infinity-250)_0%,var(--color-wtw-ultraviolet-200)_78.65%)]',
  aiBorderIconFocusVisible:
    'focus-visible:bg-[linear-gradient(107.44031564647187deg,var(--color-wtw-infinity-250)_0%,var(--color-wtw-ultraviolet-200)_78.65%)]',
} as const;

export const novaGradientSvgStop = {
  aiBorderIcon: [
    { offset: '0%', stopColor: 'var(--color-wtw-infinity-250)' },
    { offset: '78.65%', stopColor: 'var(--color-wtw-ultraviolet-200)' },
  ],
} as const;

export type NovaAssistGradientName = keyof typeof novaGradientClass;
